/**
 * Login Form Component
 *
 * Allows users to login with email and password
 */

import { useState } from 'preact/hooks';
import { useAuth } from '../../hooks/useAuth';
import { route } from 'preact-router';
import logoSvg from '../../assets/logo.svg';

export function LoginForm() {
  const { login, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    setError(null);

    // Basic validation
    if (!email || !password) {
      setError('Por favor, completa todos los campos');
      return;
    }

    if (!email.includes('@')) {
      setError('Por favor, ingresa un email válido');
      return;
    }

    try {
      await login(email, password);
      // Redirect will be handled by parent component based on user status
      route('/');
    } catch (err) {
      console.log(err);
      setError(err instanceof Error ? err.message : 'Error al iniciar sesión');
    }
  };

  return (
    <div class="w-full max-w-md">
      <div class="flex justify-center mb-6">
        <img src={logoSvg} alt="FIT-Book" class="h-16" />
      </div>
      <form onSubmit={handleSubmit} class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <h2 class="text-2xl font-bold mb-6 text-center">Iniciar Sesión</h2>

        {error && (
          <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="tu@email.com"
            disabled={loading}
            required
          />
        </div>

        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
            Contraseña
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="********"
            disabled={loading}
            required
          />
        </div>

        <div class="flex items-center justify-between">
          <button
            type="submit"
            disabled={loading}
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50 disabled:cursor-not-allowed w-full"
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </div>

        <div class="text-center mt-4">
          <a href="/registro" class="text-blue-500 hover:text-blue-700 text-sm">
            ¿No tienes cuenta? Regístrate
          </a>
        </div>
      </form>
    </div>
  );
}
